import _ from "lodash";
import React from "react";
import classes from "./QuestionBlanksTooltip.scss";
import { useI18n } from "Hooks";
import { elevations } from "@toddle-edu/ds-theme";

const QuestionBlanksTooltip = ({ insightResponse, isUniqueAnswers }) => {
  const { t } = useI18n(["worksheet", "assessmentEvaluation"]);
  if (_.isEmpty(insightResponse)) return;

  return (
    <div
      className={classes.outerTooltipContainer}
      style={elevations["elevation-2B"]}
      role="status"
      aria-live="assertive"
    >
      <div className={classes.tooltipContainer}>
        <div className={classes.tooltipInnerContainer}>
          <div className={classes.studentScoreOverview}>
            <div className={classes.studentCount}>
              {_.size(insightResponse)}
            </div>
            <div className={classes.marksRangeContainer}>
              {isUniqueAnswers
                ? t("worksheet:unique_answers_given_by_the_students")
                : t("worksheet:students_gave_the_correct_answer")}
            </div>
          </div>
          {!_.isEmpty(insightResponse) ? (
            <div className={classes.studentsContainer}>
              {_.map(insightResponse, response => (
                <div className={classes.studentDetailContainer}>
                  <div className={classes.studentNameText}>
                    {isUniqueAnswers ? response?.item : response}
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
export default QuestionBlanksTooltip;
